import React, { Component } from 'react';

class Validation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      close: true
    };
  }

  componentDidMount() {
    this.counter = setInterval(this.triger, 5000);
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.close != this.state.close) clearInterval(this.counter);
  }

  componentWillMount() {}
  componentWillUnmount() {
    clearInterval(this.counter);
  }

  triger = () => {
    this.setState({ close: false });
  };
  handleClose = e => {
    this.setState({ close: false });
  };

  handleOpen = e => {
    this.setState({ close: true });
  };

  render() {
    return (
      <React.Fragment>
        <div className={`pop-error ${!this.state.close ? 'hide' : 'show'}`}>
          <i
            className={`fas fa-times fa-times-assignador ${!this.state.close ? 'hide' : 'show'}`}
            onClick={this.handleClose}
          />
          <span
            className={`fa-stack fa-1x sp-one ${!this.state.close ? 'hover' : '-show'}`}
            onClick={this.handleOpen}
          >
            <i className="fas fa-circle  fa-circle-assignador fa-stack-1x" />
            <i className="fas fa-exclamation exclamation" />
          </span>
          <span className={`sp-twoo ${!this.state.close ? 'hide' : 'show'}`}>
            lorem ipsummmmmmmm temn pupsum nium darium
          </span>
        </div>
      </React.Fragment>
    );
  }
}

export default Validation;



// WEBPACK FOOTER //
// ./source/client/components/allocator/validation.jsx